import React, { useMemo } from "react";
import { connect } from "react-redux";
import AROpenItemsResult from "../../../../om/transactions/salesorders/salesOrderManagement/salesOrdersTab/AROpenItemsResult";
import { GetArOpenItemGridData } from "../../../../om/services/SalesOrderService";
import data from "../../../../assets/apiRoutes.json";
import { EMPTY_GUID } from '../constants';
import SelectCustomerPlaceholder from './SelectCustomerPlaceholder';

// Reuses the OM module's own customer-scoped AR Open Items grid/endpoint (proven, includes
// computed OriginalAmount/CalculatedPaid/Adjustments) rather than re-deriving those totals
// against AR's own (currently unwired) ar/OpenItem/GetOpenItems endpoint.
function OpenItemsTab(props) {
    const accessToken = props?.oidc?.user?.access_token;
    const hasCustomer = !!props.customerId && props.customerId !== EMPTY_GUID;

    const openItemsDataSource = useMemo(() => {
        if (!hasCustomer) return null;
        return GetArOpenItemGridData(accessToken, data.OM.GetArOpenItems, props.customerId);
    }, [accessToken, hasCustomer, props.customerId]);

    if (!hasCustomer) {
        return <SelectCustomerPlaceholder content="open items" />;
    }

    // AROpenItemsResult's grid uses height="100%", which needs a definite-height ancestor to
    // resolve against. Its usual home (salesOrderManagement) provides one; this tab's own
    // parent (Form.js's TabPanel) is height="auto" and doesn't, so without a concrete height
    // here the grid falls back to an oversized default instead of a bounded, scrollable box.
    return (
        <div style={{ height: '40vh' }}>
            <AROpenItemsResult data={openItemsDataSource} />
        </div>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(OpenItemsTab);
